import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { ArrowLeft, Shield, Building, Mail, Scale } from 'lucide-react';
import { Link } from 'react-router-dom';

const LegalPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white">
      {/* Header */}
      <header className="bg-white border-b border-slate-200 sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 text-slate-600 hover:text-slate-900">
            <ArrowLeft className="w-5 h-5" />
            Retour
          </Link>
          <div className="flex items-center gap-2">
            <img src="/xyron-logo.png" alt="Xyron Core ERP" className="w-8 h-8 rounded-lg" />
            <span className="font-bold">Xyron Core ERP</span>
          </div>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 py-12">
        <div className="text-center mb-12">
          <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <Scale className="w-8 h-8 text-blue-600" />
          </div>
          <h1 className="text-3xl font-bold text-slate-900 mb-2">Mentions Légales</h1>
          <p className="text-slate-500">Conformément à la législation suisse</p>
        </div>

        <div className="space-y-8">
          {/* Éditeur */}
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Building className="w-5 h-5 text-blue-600" />
                Éditeur du site
              </CardTitle>
            </CardHeader>
            <CardContent className="prose prose-slate max-w-none">
              <p><strong>Xyron Core ERP</strong></p>
              <p>
                ERP Suisse tout-en-un (SaaS)<br />
                Suisse
              </p>
              <p>
                <strong>Contact :</strong> En creant un compte d'essai gratuit, vous accedez directement a notre systeme de communication interne (Support) pour echanger avec notre equipe.
              </p>
            </CardContent>
          </Card>

          {/* Hébergement */}
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Shield className="w-5 h-5 text-green-600" />
                Hébergement
              </CardTitle>
            </CardHeader>
            <CardContent className="prose prose-slate max-w-none">
              <p>
                Le site et les données sont hébergés sur des serveurs sécurisés.<br />
                Les données sont traitées conformément à la Loi fédérale sur la protection des données (LPD).
              </p>
            </CardContent>
          </Card>

          {/* Propriété intellectuelle */}
          <Card>
            <CardHeader>
              <CardTitle>Propriété intellectuelle</CardTitle>
            </CardHeader>
            <CardContent className="prose prose-slate max-w-none">
              <p>
                L'ensemble du contenu de ce site (textes, images, logos, graphismes, icônes, logiciels) 
                est la propriété exclusive de Xyron Core ERP, sauf mention contraire.
              </p>
              <p>
                Toute reproduction, représentation, modification, publication ou adaptation de tout ou partie 
                des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite sans 
                l'autorisation écrite préalable de Xyron Core ERP.
              </p>
              <p>
                Toute exploitation non autorisée du site ou de l'un quelconque des éléments qu'il contient 
                sera considérée comme constitutive d'une contrefaçon et poursuivie conformément aux 
                dispositions du Code des obligations suisse et de la Loi fédérale sur le droit d'auteur (LDA).
              </p>
            </CardContent>
          </Card>

          {/* Responsabilité */}
          <Card>
            <CardHeader>
              <CardTitle>Limitation de responsabilité</CardTitle>
            </CardHeader>
            <CardContent className="prose prose-slate max-w-none">
              <p>
                Les informations contenues sur ce site sont aussi précises que possible et le site est 
                régulièrement mis à jour. Toutefois, il peut contenir des inexactitudes ou des omissions.
              </p>
              <p>
                Xyron Core ERP ne pourra être tenue responsable des dommages directs ou indirects résultant 
                de l'accès au site ou de l'utilisation du service, y compris l'inaccessibilité, les pertes 
                de données, détériorations, destructions ou virus qui pourraient affecter l'équipement 
                informatique de l'utilisateur.
              </p>
              <p>
                <strong>Important :</strong> Les données fiscales et comptables générées par le service sont 
                fournies à titre indicatif. L'utilisateur est responsable de la vérification de ces données 
                avec un professionnel qualifié (fiduciaire, expert-comptable) avant toute déclaration officielle.
              </p>
            </CardContent>
          </Card>

          {/* Droit applicable */}
          <Card>
            <CardHeader>
              <CardTitle>Droit applicable et juridiction</CardTitle>
            </CardHeader>
            <CardContent className="prose prose-slate max-w-none">
              <p>
                Les présentes mentions légales sont régies par le droit suisse.
              </p>
              <p>
                En cas de litige, et après échec de toute tentative de recherche d'une solution amiable, 
                les tribunaux suisses seront seuls compétents pour connaître de ce litige.
              </p>
            </CardContent>
          </Card>

          {/* Contact */}
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Mail className="w-5 h-5 text-purple-600" />
                Contact
              </CardTitle>
            </CardHeader>
            <CardContent className="prose prose-slate max-w-none">
              <p>
                Pour toute question concernant ces mentions legales ou le fonctionnement du site,
                creez un compte d'essai gratuit pour acceder a notre <strong>systeme de support interne</strong>.
                Notre equipe vous repond directement depuis l'application.
              </p>
            </CardContent>
          </Card>
        </div>

        <p className="text-center text-sm text-slate-400 mt-12">
          Dernière mise à jour : Mars 2026
        </p>
      </main>
    </div>
  );
};

export default LegalPage;
